import { Stack, Typography } from "@mui/material";

const LabelValue = ({ label, children, textDecoration }) => (
  <Stack
    direction="row"
    justifyContent="space-between"
    alignItems="flex-start"
    sx={{ py: 0.75, gap: 2 }}
  >
    <Typography
      variant="body2"
      color="text.secondary"
      sx={{
        width: { xs: 100, sm: 200 },
        flexShrink: 0,
        textDecoration,
      }}
    >
      <strong>{label}:</strong>
    </Typography>
    <Typography
      variant="body2"
      component="div"
      sx={{ ml: 2, wordBreak: "break-word", flex: 1, minWidth: 0 }}
    >
      {children}
    </Typography>
  </Stack>
);

export default LabelValue;
